import { Link } from "react-router-dom";
import { blogPreviews } from "@/mocks/homeContent";

export default function BlogPreviewSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-accent-700 tracking-widest uppercase mb-3">
            Mulebuy Spreadsheet Guides
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-3">
            Expert Sourcing Articles & Tutorials
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Dive deeper into spreadsheet-based product sourcing with our comprehensive guides. Each article is packed with actionable tips and real insights for smarter shopping.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {blogPreviews.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="w-full h-48 md:h-52 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1.5 text-xs font-medium text-primary-600">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}